export enum FundTypeIdEnum {
  Cash = 1,
  Balanced = 2,
  Equity = 3,
  Bonds = 4,
  MoneyMarket = 5
}
